import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { authApi } from '../api/endpoints.js';
import { useAuth } from '../auth/AuthContext.jsx';
import { useToast } from '../hooks/useToast.jsx';
import { useApiError } from '../hooks/useApiError.js';
import PageHeader from '../components/PageHeader.jsx';
import Card from '../components/Card.jsx';
import Badge from '../components/Badge.jsx';
import LanguageSwitcher from '../components/LanguageSwitcher.jsx';
import { Field, TextInput } from '../components/Field.jsx';
import { formatDateTime } from '../utils/format.js';

const ProfilePage = () => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const toast = useToast();
  const toMessage = useApiError();

  const [passwords, setPasswords] = useState({ currentPassword: '', newPassword: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      await authApi.changePassword(passwords);
      toast.success(t('auth.passwordChanged'));
      setPasswords({ currentPassword: '', newPassword: '' });
    } catch (err) {
      toast.error(toMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <PageHeader title={t('common.profile')} />

      <div className="grid grid--2">
        <Card title={`${user.firstName} ${user.lastName}`}>
          <dl className="detail-list">
            <div>
              <dt>{t('auth.email')}</dt>
              <dd>{user.email}</dd>
            </div>
            <div>
              <dt>{t('users.role')}</dt>
              <dd>
                <Badge value={user.role} label={t(`roles.${user.role}`)} />
              </dd>
            </div>
            <div>
              <dt>{t('users.lastLogin')}</dt>
              <dd>{user.lastLoginAt ? formatDateTime(user.lastLoginAt, i18n.resolvedLanguage) : t('users.never')}</dd>
            </div>
            <div>
              <dt>{t('common.language')}</dt>
              <dd>
                <LanguageSwitcher />
              </dd>
            </div>
          </dl>
        </Card>

        <Card title={t('auth.changePassword')}>
          <form onSubmit={submit} className="stack">
            <Field label={t('auth.currentPassword')} htmlFor="p-current" required>
              <TextInput
                id="p-current"
                type="password"
                value={passwords.currentPassword}
                onChange={(value) => setPasswords({ ...passwords, currentPassword: value })}
                required
              />
            </Field>
            <Field label={t('auth.newPassword')} htmlFor="p-new" required hint="min. 8">
              <TextInput
                id="p-new"
                type="password"
                value={passwords.newPassword}
                onChange={(value) => setPasswords({ ...passwords, newPassword: value })}
                required
              />
            </Field>
            <button type="submit" className="btn btn--primary" disabled={busy}>
              {busy ? t('common.saving') : t('common.save')}
            </button>
          </form>
        </Card>
      </div>
    </>
  );
};

export default ProfilePage;
